import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IOption } from "@faire/web--source/slate/Input/Dropdown";

const STOCKIST_OPTIONS = (strictLocalize: StrictLocalizeFunction) => [
  {
    label: strictLocalize({ defaultMessage: "I am new to wholesale" }),
    value: 0,
  },
  {
    label: strictLocalize({
      defaultMessage: "1-10",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 10,
  },
  {
    label: strictLocalize({
      defaultMessage: "11-25",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 25,
  },
  {
    label: strictLocalize({
      defaultMessage: "26-50",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 50,
  },
  {
    label: strictLocalize({
      defaultMessage: "51-100",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 100,
  },
  {
    label: strictLocalize({
      defaultMessage: "101-250",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 250,
  },
  {
    label: strictLocalize({
      defaultMessage: "251-500",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 500,
  },
  {
    label: strictLocalize({
      defaultMessage: "500-1000",
      description: {
        text: "Translate for the correct dash mark in different languages",
      },
    }),
    value: 1000,
  },
  {
    label: strictLocalize({
      defaultMessage: "More than 1000",
      description: {
        text: 'Indicating the "More than 1000" retailers that they have sold to',
      },
    }),

    value: 1001,
  },
];

export const STOCKIST_IOPTIONS = (
  strictLocalize: StrictLocalizeFunction
): IOption[] =>
  STOCKIST_OPTIONS(strictLocalize).map((option) => ({
    label: option.label,
    value: option.value.toString(),
  }));
